import { atom } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";

export type scheduleType = {
  reboot_date: number[];
  reboot_time: string;
  screen_off_time: string | null;
  return_to_main_time_1: string | null;
  return_to_main_time_2: string | null;
};

export const scheduleState = atom<scheduleType>({
  key: "deviceSchedule",
  default: {
    reboot_date: [0, 0, 0, 0, 0, 0, 0],
    reboot_time: "13:00:00",
    screen_off_time: "02:00:00",
    return_to_main_time_1: "11:00:00",
    return_to_main_time_2: "17:00:00",
  },
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("schedule");

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("schedule")
          : AsyncLocalStorage.setItem("schedule", JSON.stringify(newValue));
      });
    },
  ],
});
